import { watch, ref, onMounted } from 'vue';
import { useMediaQuery } from '@vueuse/core';

import { isSSR } from '#shared/utils/isSSR';
import { viewTypes, DESKTOP_MINIMUM_SCREEN_WIDTH } from '#shared/constants';
import useProvideFactory from '~/composables/dumb/useProvideFactory';

export const VIEW_TYPE_REPOSITORY = Symbol('VIEW_TYPE_REPOSITORY');

export function getViewTypeSharedState() {
  const viewType = ref(null);
  return { viewType };
}

export function useViewTypeProvide(useAsInject) {
  return useProvideFactory({
    key: VIEW_TYPE_REPOSITORY,
    factory: getViewTypeSharedState,
    useAsInject,
  });
}

export default function useInit({ isPhone }) {
  const { viewType } = useViewTypeProvide(true);
  const { isNavSSR } = useEnvProps();

  if (viewType.value) {
    return { viewType };
  }

  if (!viewType.value) {
    const navViewType = useNavViewType();
    viewType.value = navViewType?.viewType; // set default value from store
  }

  // Handle SSR
  if (isSSR()) {
    if (!viewType.value) {
      viewType.value = isPhone ? viewTypes.mobile : viewTypes.desktop;
    }
  } else {
    // Handle Client
    const isDesktopMediaQuery = useMediaQuery(`(min-width: ${DESKTOP_MINIMUM_SCREEN_WIDTH}px)`);

    const updateViewType = () => {
      viewType.value = isDesktopMediaQuery.value ? viewTypes.desktop : viewTypes.mobile;
    };

    if (isNavSSR) {
      onMounted(() => {
        updateViewType();
        watch(isDesktopMediaQuery, updateViewType);
      });
    } else {
      updateViewType();
      watch(isDesktopMediaQuery, updateViewType);
    }
  }

  return { viewType };
}
